import { Settings } from '@mui/icons-material';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ColorPicker } from '~/components/ColorPicker';
import { useAppearance, useUpdateAppearanceSettings } from '~/data/appearance';
// import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { legacyColors } from '~/legacyTheme';

import { postAppearanceSettings } from './data';
import { useSxStyles } from './useStyles';

export const PortalBrandingSettings = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { customAppearance, isLoading: appearanceLoading } = useAppearance();
  const updateAppearanceSettings = useUpdateAppearanceSettings();

  const [upperBarColor, setUpperBarColor] = React.useState(legacyColors.grey1);
  const [upperBarFontColor, setUpperBarFontColor] = React.useState(
    legacyColors.black,
  );
  const [menuBackgroundColor, setMenuBackgroundColor] = React.useState(
    legacyColors.grey6,
  );
  const [menuFontColor, setMenuFontColor] = React.useState(legacyColors.black);
  useEffect(() => {
    if (!appearanceLoading) {
      const colorsSet =
        customAppearance.fTopBarColors &&
        customAppearance.fTopBarColors.fBackgroundColor !== '' &&
        customAppearance.fLeftSideMenuColors.fBackgroundColor !== '';
      setUpperBarColor(
        colorsSet
          ? customAppearance.fTopBarColors.fBackgroundColor
          : legacyColors.grey1,
      );
      setUpperBarFontColor(
        colorsSet
          ? customAppearance.fTopBarColors.fIconsColor
          : legacyColors.black,
      );
      setMenuBackgroundColor(
        colorsSet
          ? customAppearance.fLeftSideMenuColors.fBackgroundColor
          : legacyColors.grey6,
      );
      setMenuFontColor(
        colorsSet
          ? customAppearance.fLeftSideMenuColors.fIconsColor
          : legacyColors.black,
      );
    }
  }, [customAppearance, appearanceLoading]);

  const onReset = () => {
    setUpperBarColor(legacyColors.grey1);
    setUpperBarFontColor(legacyColors.black);
    setMenuBackgroundColor(legacyColors.grey6);
    setMenuFontColor(legacyColors.black);
  };

  const onSave = async () => {
    try {
      const formData = new FormData();
      formData.append(
        'fShowAnnouncement',
        customAppearance.fShowAnnouncement
          ? customAppearance.fShowAnnouncement.toString()
          : 'false',
      );
      formData.append(
        'fBackground',
        customAppearance.fAppearanceBackground
          ? customAppearance.fAppearanceBackground
          : '',
      );
      formData.append(
        'fGreetingTranslations',
        JSON.stringify(
          customAppearance.fGreetingTranslations
            ? customAppearance.fGreetingTranslations
            : [],
        ),
      );
      formData.append('fTopBarColors.fBackgroundColor', upperBarColor);
      formData.append('fTopBarColors.fIconsColor', upperBarFontColor);
      formData.append(
        'fLeftSideMenuColors.fBackgroundColor',
        menuBackgroundColor,
      );
      formData.append('fLeftSideMenuColors.fIconsColor', menuFontColor);

      await postAppearanceSettings(formData).then((data) => {
        updateAppearanceSettings(data);
      });
      enqueueSnackbar(t('message_success_approval'), {
        variant: 'success',
      });
    } catch (e) {
      console.error(e);
      enqueueSnackbar(t('laGeneralError'), {
        variant: 'error',
      });
    }
  };

  return (
    <Box sx={{ width: '800px' }}>
      <Stack spacing={5} sx={{ mt: '10px' }}>
        {/*TODO Enabled Topbar branding when management decides*/}
        {/*<Box>*/}
        {/*  <Typography sx={{ fontWeight: 'bold' }}>*/}
        {/*    {t('topbarColorSettings')}*/}
        {/*  </Typography>*/}
        {/*  <Grid container>*/}
        {/*    <Grid item xs={6} container direction="row">*/}
        {/*      <Box sx={sxStyles.boxStyles}>*/}
        {/*        <Typography>{t('background')}</Typography>*/}
        {/*        <ColorPicker*/}
        {/*          color={upperBarColor}*/}
        {/*          onChange={(color: string) => setUpperBarColor(color)}*/}
        {/*        />*/}
        {/*      </Box>*/}
        {/*      <Box sx={sxStyles.boxStyles}>*/}
        {/*        <Typography>{t('actionButtons')}</Typography>*/}
        {/*        <ColorPicker*/}
        {/*          color={upperBarFontColor}*/}
        {/*          onChange={(color: string) => setUpperBarFontColor(color)}*/}
        {/*        />*/}
        {/*      </Box>*/}
        {/*    </Grid>*/}
        {/*    <Grid*/}
        {/*      item*/}
        {/*      xs={6}*/}
        {/*      container*/}
        {/*      direction="column"*/}
        {/*      justifyContent="center"*/}
        {/*    >*/}
        {/*      <Box*/}
        {/*        sx={{*/}
        {/*          width: '150px',*/}
        {/*          height: '50px',*/}
        {/*          backgroundColor: upperBarColor,*/}
        {/*          display: 'flex',*/}
        {/*          justifyContent: 'center',*/}
        {/*          border: '1px solid black',*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        <Button*/}
        {/*          sx={{*/}
        {/*            ...sxStyles.navItem,*/}
        {/*            color: upperBarFontColor,*/}
        {/*            backgroundColor: upperBarColor,*/}
        {/*            '&:hover': {*/}
        {/*              backgroundColor: `${upperBarFontColor}40`,*/}
        {/*            },*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          <LegacyFAIcon FAIcon={LegacyFAIcons.UserPlus} />*/}
        {/*        </Button>*/}
        {/*        <Button*/}
        {/*          sx={{*/}
        {/*            ...sxStyles.navItem,*/}
        {/*            color: upperBarFontColor,*/}
        {/*            backgroundColor: upperBarColor,*/}
        {/*            '&:hover': {*/}
        {/*              backgroundColor: `${upperBarFontColor}40`,*/}
        {/*            },*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          <LegacyFAIcon FAIcon={LegacyFAIcons.Cog} />*/}
        {/*        </Button>*/}
        {/*      </Box>*/}
        {/*    </Grid>*/}
        {/*  </Grid>*/}
        {/*</Box>*/}
        <Box>
          <Typography sx={{ fontWeight: 'bold' }}>
            {t('menuColorSettings')}
          </Typography>
          <Grid container>
            <Grid item xs={6} container direction="row">
              <Box sx={sxStyles.boxStyles}>
                <Typography>{t('background')}</Typography>
                <ColorPicker
                  color={menuBackgroundColor}
                  onChange={(color: string) => setMenuBackgroundColor(color)}
                />
              </Box>
              <Box sx={sxStyles.boxStyles}>
                <Typography>{t('actionButtons')}</Typography>
                <ColorPicker
                  color={menuFontColor}
                  onChange={(color: string) => setMenuFontColor(color)}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              container
              direction="column"
              justifyContent="center"
            >
              <Box
                sx={{
                  width: '150px',
                  height: '50px',
                  backgroundColor: menuBackgroundColor,
                  display: 'flex',
                  justifyContent: 'center',
                  border: '1px solid black',
                }}
              >
                <Button
                  sx={{
                    color: menuFontColor,
                    '&:hover': {
                      backgroundColor: `${menuFontColor}40`,
                    },
                  }}
                  size="small"
                  startIcon={<Settings />}
                >
                  {t('configure')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Stack>
      <Button sx={{ float: 'right' }} variant="contained" onClick={onSave}>
        {t('laSave')}
      </Button>
      <Button sx={{ float: 'right' }} onClick={onReset}>
        {t('laReset')}
      </Button>
    </Box>
  );
};
